import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { FetchConfigurationByNameResData } from "./FetchConfigurationByNameResData";

const ENDPOINT = "/config";

export class FetchConfigurationByNameCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";
    params = null;

    constructor(configName: string) {
        super();
        this.endPoint = this.endPoint + "/" + configName;
    }

    public async execute(): Promise<FetchConfigurationByNameResData> {
        var res = await this.executeCommand(null, null, this.params);
        return new FetchConfigurationByNameResData(res);
    }
}
